import { createSlice } from "@reduxjs/toolkit";
import { useSelector } from "react-redux";

const initialState = {
  otherGroups: {},
};

const otherGroupsSlice = createSlice({
  name: "otherGroups",
  initialState: initialState,
  reducers: {
    saveOtherGroup: (state, action) => {
      state.otherGroups = { ...state.otherGroups, ...action.payload };
    },
    clearOtherGroup: (state) => {
      state.otherGroups = initialState.otherGroups;
    },
  },
});

export const useOtherSearchGroupSlice = () => {
  const otherGroups = useSelector(
    (state: any) => state.otherGroups.otherGroups
  );
  return {
    otherGroups,
  };
};
export const { saveOtherGroup, clearOtherGroup } = otherGroupsSlice.actions;
export default otherGroupsSlice.reducer;
